import { msg } from 'gt-react';
import { EnvelopeSimpleIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute, requireModules } from '../route';

const EdiTextMessagesPage = lazyRouteComponent(
  () => import('./EdiTextMessagesPage'),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/edi-text-messages',
  staticData: {
    app: {
      nav: {
        label: msg('EDI Text Messages', {
          context: 'sidebar nav label, Sales section',
        }),
        icon: <EnvelopeSimpleIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 57,
      },
      access: {
        modulesAnyOf: [ProductModule.ORDERFUL_EDI],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SalesOrder },
        ],
      },
    },
  },
  component: EdiTextMessagesPage,
  loader: () => ({
    crumb: msg('EDI Text Messages', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDERFUL_EDI],
    });
  },
});
